import React from 'react';
import { Card } from '@paypalcorp/pp-react';
import { useNavigate } from 'react-router';
import styles from './../CardsList.module.less';
import { trackButtonClick } from '../../../lib/fpti';
import isAbsolutePath from '../../../util/isAbsolutePath';
import LinkCard from './LinkCard';
import BaseCard from './BaseCard';
import ImageCard from './ImageCard';
import IconCard from './IconCard';

export type CardEcmContent = {
  title: string;
  cardType: string;
  overrideCardType?: string;
  subTitle?: string;
  description?: string;
  image?: string;
  CTAButtonLabel?: string;
  CTAButtonURL?: string;
  url?: string;
  icon?: string;
  titleStyles?: React.CSSProperties;
  style?: React.CSSProperties;
};

type DynamicCardProps = {
  ecmContent: CardEcmContent;
  listCardType?: string;
};

const DynamicCard: React.FC<DynamicCardProps> = ({ ecmContent, listCardType }) => {
  const {
    title,
    cardType = listCardType,
    overrideCardType,
    subTitle,
    description,
    image,
    CTAButtonLabel,
    CTAButtonURL,
    url,
    icon,
    titleStyles: ecmTitleStyles = {},
    style: ecmCardStyles = {}
  } = ecmContent;
  const navigate = useNavigate();

  const handleNavigation = () => {
    trackButtonClick(title, 'card_click');
    if (!url) {
      return;
    }

    if (isAbsolutePath(url)) {
      window.open(url, '_blank');
    } else {
      navigate(url);
    }
  };

  const finalCardType = overrideCardType ? overrideCardType : cardType;
  const renderCard = () => {
    switch (finalCardType) {
      case 'icon':
        return (
          <IconCard
            ecmContent={{ icon, title, subTitle, description, titleStyles: ecmTitleStyles }}
          />
        );
      case 'image':
        return (
          <ImageCard
            ecmContent={{ image, title, subTitle, description, titleStyles: ecmTitleStyles }}
          />
        );
      case 'basic':
        return (
          <BaseCard ecmContent={{ title, subTitle, description, titleStyles: ecmTitleStyles }} />
        );
      case 'imagewithlink':
        return (
          <LinkCard
            ecmContent={{
              image,
              title,
              subTitle,
              description,
              CTAButtonLabel,
              CTAButtonURL,
              titleStyles: ecmTitleStyles
            }}
          />
        );
      default:
        return null;
    }
  };

  return (
    <Card onClick={handleNavigation} className={styles.card} style={ecmCardStyles}>
      {renderCard()}
    </Card>
  );
};

export default DynamicCard;
